import { render, staticRenderFns } from "./ErrorLogDetail.vue?vue&type=template&id=5f874e94&scoped=true"
import script from "./ErrorLogDetail.vue?vue&type=script&lang=js"
export * from "./ErrorLogDetail.vue?vue&type=script&lang=js"
import style0 from "./ErrorLogDetail.vue?vue&type=style&index=0&id=5f874e94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f874e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f874e94')) {
      api.createRecord('5f874e94', component.options)
    } else {
      api.reload('5f874e94', component.options)
    }
    module.hot.accept("./ErrorLogDetail.vue?vue&type=template&id=5f874e94&scoped=true", function () {
      api.rerender('5f874e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/errorlog/ErrorLogDetail.vue"
export default component.exports